import { createFileRoute, redirect } from '@tanstack/react-router';
import { getJ5ArtifactDownloadQueryOptions } from '@interxfi/api-client/registry/download-artifact';
import { DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE, PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { VerticalStack } from '@interxfi/design-system/components/alignment/vertical-stack';
import { MdxProse } from '../../../../../features/docs/prose/mdx-prose';

export const Route = createFileRoute('/docs/_layout/api-reference/_provider/')({
  beforeLoad: ({ context }) => {
    if (!context.effectiveVersion) {
      throw redirect({ to: '/docs', search: true });
    }
  },
  loader: async ({ context }) => {
    const markdown = context.effectiveVersion
      ? ((await context.queryClient.ensureQueryData(
          getJ5ArtifactDownloadQueryOptions({
            owner: 'interxfi',
            bundle: 'getting-started',
            version: context.effectiveVersion,
            name: 'intro',
          }),
        )) as string)
      : '# Getting Started';

    return { markdown } as const;
  },
  preload: true,
  component: DocsApiReferenceIndex,
});

function DocsApiReferenceIndex() {
  const { markdown } = Route.useLoaderData();

  return (
    <PageLayout maxWidthContainer={DEFAULT_PAGE_LAYOUT_MAX_WIDTH_CONTAINER_SIZE}>
      <PageLayout.Section>
        <VerticalStack as="section" gap={7}>
          <MdxProse mdx={markdown} />
        </VerticalStack>
      </PageLayout.Section>
    </PageLayout>
  );
}
